export default "__VITE_ASSET__5bf06bc3__"